import React, { PureComponent } from 'react';
import { Link, Route, matchPath } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import {
  Accordion,
  AccordionHeader,
  AccordionItem,
  Col,
  DataItem,
  PageWrapper,
  PaperContent,
  Paper,
  Row,
} from 'virtues-bootstrap';
import { map } from 'ramda';

import ChangePassword from 'containers/ChangePassword';
import Feedback from 'containers/Feedback';
import UserInfo from 'containers/UserInfo';
import PrivacyPolicyText from 'components/PrivacyPolicyText';
import UserLicense from 'components/UserLicense';

import s from './styles.module.scss';

const accordionItems = [
  {
    component: Feedback,
    title: 'feedback.feedback',
    url: '/feedback',
  },
  {
    component: ChangePassword,
    title: 'changePassword.changePassword',
    url: '/change-password',
  },
  {
    component: PrivacyPolicyText,
    title: 'privacyPolicy.title',
    url: '/policy',
  },
  {
    component: UserLicense,
    title: 'userLicenceAgreement.title',
    url: '/user-license-agreement',
  },
];

class ResearcherProfile extends PureComponent {
  static propTypes = {
    location: ReactRouterPropTypes.location.isRequired,
    match: ReactRouterPropTypes.match.isRequired,
    t: PropTypes.func.isRequired,
    creationDate: PropTypes.string.isRequired,
  };

  renderAccordionItem = ({ component: Component, title, url }) => {
    const { location, match, t } = this.props;
    const isActive = !!matchPath(location.pathname, `${match.path}${url}`);

    return (
      <AccordionItem key={url}>
        <AccordionHeader
          active={isActive}
          component={Link}
          to={isActive ? match.url : `${match.url}${url}`}
        >
          {t(title)}
        </AccordionHeader>
        <Route path={`${match.url}${url}`} component={Component} />
      </AccordionItem>
    );
  };

  render() {
    const { creationDate, t } = this.props;

    return (
      <PageWrapper>
        <Row>
          <Col xs={4}>
            <Paper>
              <UserInfo />
              <PaperContent className={s.sidebarPaper}>
                <DataItem className={s.dataItem} title={t('patient.profileCreatedOn')}>
                  {creationDate}
                </DataItem>
              </PaperContent>
            </Paper>
          </Col>
          <Col xs={8}>
            <Paper>
              <Accordion>{map(this.renderAccordionItem, accordionItems)}</Accordion>
            </Paper>
          </Col>
        </Row>
      </PageWrapper>
    );
  }
}

export default withTranslation()(ResearcherProfile);
